import { render, staticRenderFns } from "./FormHandover.vue?vue&type=template&id=b39602fe&"
import script from "./FormHandover.vue?vue&type=script&lang=js&"
export * from "./FormHandover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports